import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map, Observable, Subject } from 'rxjs';

import { SvcDialogService } from '@solvace/component/svc-dialogs';
import { SvcModalBosType } from '../enums/svc-modal-bos.enum';
import { SvcModalBosComponent } from '../../svc-modal-bos.component';
import { AppEnvironmentConfig } from 'projects/config/model/environment.config.model';
import { ISvcSelectOption } from '@solvace/component/svc-controls';
import { UserService } from 'projects/lib-shared-core/src/lib/features/user/services/user.service';
import { SvcTotalsStatusComponent } from '@solvace/feature/general/svc-totals-status';

@Injectable({
  providedIn: 'root',
})
export class SvcModalBosService {
  private _totalsStatusComponents: SvcTotalsStatusComponent[] = [];
  private readonly _apiBos: string = this._appConfig.APIs.apiUrlBOS;
  public bosAdd$ = new Subject<void>();
  public bosUpdated$ = new Subject<number>();
  public bookmarkStatusUpdated$ = new Subject<number>();

  constructor(
    private _appConfig: AppEnvironmentConfig,
    private _dialogService: SvcDialogService,
    private _http: HttpClient,
    private _userService: UserService
  ) {
    this._monitorBosUpdates();
  }

  public openModalBos(mode = SvcModalBosType.add, id?: number, uniqueId?: number): void {
    this._dialogService.open(SvcModalBosComponent, {
      data: { mode, id, uniqueId },
      width: '100%',
      maxWidth: '500px',
      panelClass: 'md:py-4',
      autoFocus: false,
    });
  }

  public registerTotalsStatus(components: SvcTotalsStatusComponent[]): void {
    this._totalsStatusComponents = components;
  }

  public updateTotalsStatus(components: SvcTotalsStatusComponent[]): void {
    this._totalsStatusComponents = components;
  }

  private _monitorBosUpdates(): void {
    this.bosUpdated$.subscribe((bosId) => {
      this._totalsStatusComponents?.find((svcTotalStatus) => svcTotalStatus.referenceId === bosId)?.refresh();
    });
  }

  public getTypes(): Observable<ISvcSelectOption[]> {
    return this._http
      .get<{ typeId: number; typeName: string }[]>(`${this._apiBos}/Type/BySiteId`, {
        params: {
          siteId: this._userService.user.lastSiteId,
        },
      })
      .pipe(
        map((types) =>
          types?.map((type) => ({
            text: type.typeName,
            value: type.typeId,
          }))
        )
      );
  }
}
